// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import SearchBar from 'components/Search/SearchBar'

// Redux:
import { openSearch, closeSearch } from 'actions/search'

class Search extends React.Component {
	handleFindChurch = ( e ) => {
		e.preventDefault()

		this.props.openMap()
	}

	render() {
		return (
			<div className="search-wrap">
				<SearchBar />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		searchIsOpen: state.search.isOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		openSearch() {
			dispatch( openSearch() )
		},

		closeSearch() {
			dispatch( closeSearch() )
		}
	}
}

export default localize(
	connect( mapStateToProps, mapDispatchToProps )( Search )
)



// WEBPACK FOOTER //
// ./components/Search/Search.jsx